import { LLM_MODELS, getLlmModelLabel } from '../../models/LlmModel'
import { FIELD_CLASS, LABEL_CLASS } from '../inputs/fieldStyles'

type Props = {
    value: string
    onChange: (value: string) => void
    disabled?: boolean
    /** Overrides the select styling, e.g. to add the read-only dimming. */
    selectClassName?: string
}

/**
 * The LLM picker for a classifier version.
 *
 * An older version can name a model that's since been dropped from LLM_MODELS. That
 * value is kept as an extra option so viewing or saving such a version doesn't
 * silently rewrite it to whatever happens to be first in the list.
 */
export default function ModelSelect({ value, onChange, disabled, selectClassName }: Props) {
    const isRetiredModel = value !== '' && !LLM_MODELS.some((m) => m.id === value)

    return (
        <div className="flex-1 min-w-[12rem]">
            <label htmlFor="model" className={LABEL_CLASS}>
                Model
            </label>
            <select
                id="model"
                value={value}
                disabled={disabled}
                onChange={(e) => onChange(e.target.value)}
                className={selectClassName ?? FIELD_CLASS}
            >
                {isRetiredModel && <option value={value}>{value}</option>}
                {LLM_MODELS.map((m) => (
                    <option key={m.id} value={m.id}>
                        {getLlmModelLabel(m)}
                        {m.isDefault ? ' (default)' : ''}
                    </option>
                ))}
            </select>
        </div>
    )
}
